import { render, staticRenderFns } from "./LandingPageHeader.vue?vue&type=template&id=2136aba0"
import script from "./LandingPageHeader.vue?vue&type=script&lang=js"
export * from "./LandingPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports